'use client';

import type React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import type { ArtistData } from '../../types';
import Gradient from '../Gradient';
import MediaButtons from '../MediaButtons';
import { StyledDownArrow, StyledH1Bold, StyledJoevLogo, StyledWelcomeContainer } from '../styled';

export type WelcomeProps = {
  handleLogoClicked: () => void;
  logoClicked: boolean;
  handleAnimationEnd: () => void;
  handleDownClicked: () => void;
  releaseAmount?: number;
  joevData: ArtistData;
  bgColor?: string;
};

/**
 * Full 100vh Hero welcome section with drawing logo animation, headline, and media links.
 */
export const Welcome: React.FC<WelcomeProps> = ({
  handleLogoClicked,
  logoClicked,
  handleAnimationEnd,
  handleDownClicked,
  joevData,
}) => {
  const { t } = useLanguage();

  return (
    <StyledWelcomeContainer className="container-fluid text-center">
      <Gradient />

      <div
        style={{
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <StyledJoevLogo
          onClick={handleLogoClicked}
          onAnimationEnd={handleAnimationEnd}
          className={logoClicked ? 'drawIn' : 'drawOut'}
          aria-label="joev noise logo"
          role="button"
          tabIndex={0}
        />

        <StyledH1Bold>{t('welcomeGreeting')}</StyledH1Bold>

        <div
          className="d-flex justify-content-center align-items-center flex-wrap"
          style={{ marginTop: '12px', gap: '8px' }}
        >
          <MediaButtons
            links={joevData.links}
            isInViewport={true}
            bgColor={'rgba(80,220,80,0.8)'}
            spacing={'6px'}
            size={'0.8'}
          />
        </div>
      </div>

      <StyledDownArrow
        className="downArrow"
        onClick={handleDownClicked}
        aria-label={t('welcomeScrollPrompt')}
        role="button"
        tabIndex={0}
      />
    </StyledWelcomeContainer>
  );
};

export default Welcome;
